<template>
	<span class="UserIcon">
    <span class="initials" v-if="(user||{}).first_name && (user||{}).last_name" >
      {{ user.first_name.substring(0,1) }}
      {{ user.last_name.substring(0,1) }}
    </span>
  </span>
</template>

<script>

	export default {
  	props:['user'],
	}

</script>